import {i18n} from '@online-offer/i18n';
import {Box, Heading, HStack, Image, Show, VStack} from 'platform/foundation';

import {any, values} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {SectionPrint} from '../../components/SectionPrint/SectionPrint';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {getDataForTechnicalParameters} from '../../utils/getDataForTechnicalParameters';
import {placeholderFallback} from '../../utils/placeholderFallback';
import {TechnicalParametersItem} from '../TechnicalParametersItem/TechnicalParametersItem';

export function TechnicalParametersPrint() {
  const {vehicle} = useGetOnlineOfferData();
  const data = getDataForTechnicalParameters(vehicle);

  if (
    !any(
      isNotNilOrEmpty,
      values([
        data.dimensions.height,
        data.dimensions.length,
        data.dimensions.width,
        data.details.trunkSpace,
        data.details.operatingWeight,
        data.details.weight,
        data.details.maximalLoadCapacity,
      ])
    )
  ) {
    return null;
  }

  return (
    <SectionPrint heading={i18n.t('technicalParameters.heading')}>
      <HStack align="flex-start" spacing={10}>
        <Box flex={1}>
          <VStack spacing={4}>
            <Heading size={5} headingLevel={4} color="secondary">
              {`${i18n.t('details.heading')}`}
            </Heading>
            <Show when={isNotNilOrEmpty(data.dimensions.height)}>
              <Heading size={6} headingLevel={5} color="secondary">
                {i18n.t('technicalParameters.dimension.height', {
                  value: placeholderFallback(data.dimensions.height),
                })}
              </Heading>
            </Show>
            <Show when={isNotNilOrEmpty(data.dimensions.length)}>
              <Heading size={6} headingLevel={5} color="secondary">
                {i18n.t('technicalParameters.dimension.length', {
                  value: placeholderFallback(data.dimensions.length),
                })}
              </Heading>
            </Show>
            <Show when={isNotNilOrEmpty(data.dimensions.width)}>
              <Heading size={6} headingLevel={5} color="secondary">
                {i18n.t('technicalParameters.dimension.width', {
                  value: placeholderFallback(data.dimensions.width),
                })}
              </Heading>
            </Show>
          </VStack>
        </Box>
        <Box flex={1}>
          <Image
            borderRadius="small"
            src="../../assets/images/vehicle.jpeg"
            height={60}
            alt={i18n.t('technicalParameters.vehicleImage')}
            width={80}
            isLazy
            hasSpinner
          />
        </Box>
        <Box flex={1}>
          <VStack spacing={4}>
            <Show when={isNotNilOrEmpty(data.details.trunkSpace)}>
              <TechnicalParametersItem
                value={`${data.details.trunkSpace} l`}
                icon="technicalParams/trunk"
                title={i18n.t('technicalParameters.item.trunk')}
              />
            </Show>
            <Show when={isNotNilOrEmpty(data.details.operatingWeight)}>
              <TechnicalParametersItem
                value={`${data.details.operatingWeight} kg`}
                icon="technicalParams/weight"
                title={i18n.t('technicalParameters.item.towing')}
              />
            </Show>
            <Show when={isNotNilOrEmpty(data.details.weight)}>
              <TechnicalParametersItem
                value={`${data.details.weight} kg`}
                icon="technicalParams/weight"
                title={i18n.t('technicalParameters.item.weight')}
              />
            </Show>
            <Show when={isNotNilOrEmpty(data.details.maximalLoadCapacity)}>
              <TechnicalParametersItem
                value={`${data.details.maximalLoadCapacity} kg`}
                icon="technicalParams/weight"
                title={i18n.t('technicalParameters.item.maximalLoadCapacity')}
              />
            </Show>
          </VStack>
        </Box>
      </HStack>
    </SectionPrint>
  );
}
